import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';

import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';

import styles from './CallToAction.scss';

export type CallToActionProps = {
  ctaButtonLabel: string,
  ctaHref: string,
  ctaTagline: string | React.ReactNode;
  onClick: () => void;
  showOnMobile?: boolean;
}
export const CallToAction = ({ ctaButtonLabel, ctaHref, ctaTagline, onClick, showOnMobile }: CallToActionProps) => {
  const breakpoints = useBreakpoint();
  const isTabletMobile = !breakpoints?.maxWidth?.breakpointTabletMobile;

  return (
    <div className={cx(styles.component, { [styles.showOnMobile]: showOnMobile })}>
      <div className={styles.tagline}>
        <p className={styles.ctaTagline}>{ctaTagline}</p>
      </div>
      <div className={styles.cta}>
        <Button as={Link} {...applyCypressData(cypressIds.buttons.cta)} fullWidth={true} icon='chevron' label={ctaButtonLabel} onClick={onClick} size={isTabletMobile ? 'large' : 'medium'} to={ctaHref}/>
      </div>
    </div>
  );
};
